import TooltipInfo from './TooltipInfo'

export default TooltipInfo
